/**
 * Student Detail JS
 */
import * as lpUtils from "../utils";
import MicroModal from 'micromodal';
import Chart from "chart.js/auto";

const exportCSV = ( e, target ) => {
	if ( ! target.closest( '.lp-btn-gradebook-export-csv' ) ) {
		return;
	}

	lpUtils.lpSetLoadingEl( target, 1 );

	const dataSendString = target.dataset.send ? target.dataset.send : '';
	const dataSend = dataSendString ? JSON.parse( dataSendString ) : {};

	const callBack = {
		success: ( response ) => {
			const { message, status, data } = response;
			const { file, filename, finish, deleted } = data;

			if ( status !== 'success' ) {
				lpUtils.lpSetLoadingEl( target, 0 );
				alert( message );
				return;
			}

			if ( ! finish ) {
				 dataSend.paged++;

				 setTimeout( () => {
					 window.lpAJAXG.fetchAJAX( dataSend, callBack );
				 }, 500 );
			} else {
				const elLink = document.createElement('a');
				elLink.href = data.file;
				elLink.download = data.filename;
				document.body.appendChild(elLink);
				elLink.click();
				document.body.removeChild(elLink);
				lpUtils.lpSetLoadingEl( target, 0 );
				dataSend.delete_file = true;
				window.lpAJAXG.fetchAJAX( dataSend, {} );
			}
		},
		error: ( error ) => {
			console.log( error );
		},
		completed: () => {

		},
	};

	window.lpAJAXG.fetchAJAX( dataSend, callBack );
}
const showChart = ( e, target ) => {
	if ( ! target.closest( '.lp-btn-gradebook-view-chart' ) ) {
		return;
	}

	MicroModal.show('lp-gradebook-chart-modal');
	const elChart = document.querySelector( '#lp-gradebook-chart-modal' );
	const elLoading = elChart.querySelector( '.lp-skeleton-animation' );
	const elChartMain = elChart.querySelector( '.lp-gradebook-chart-main' );

	if ( elLoading.classList.contains( lpUtils.lpClassName.hidden ) ) {
		return;
	}

	const dataSendString = target.dataset.send ? target.dataset.send : '';
	const dataSend = dataSendString ? JSON.parse( dataSendString ) : {};

	const callBack = {
		success: ( response ) => {
			const { message, status, data } = response;

			if ( status !== 'success' ) {
				lpUtils.lpSetLoadingEl( target, 0 );
				alert( message );
				return;
			}

			const { labels, datasets } = data;
			renderBarChart( labels, datasets );
			lpUtils.lpShowHideEl( elLoading, 0 );
			lpUtils.lpShowHideEl( elChartMain, 1 );
		},
		error: ( error ) => {
			console.log( error );
		},
		completed: () => {
			lpUtils.lpSetLoadingEl( target, 0 );
		},
	};

	window.lpAJAXG.fetchAJAX( dataSend, callBack );
}
const filterChart = ( e, target ) => {
	if ( ! target.closest( '.lp-btn-gradebook-filter' ) ) {
		return;
	}

	const elWrap = target.closest( '.lp-gradebook-filter-chart-wrap' );
	const dataSendString = elWrap && elWrap.dataset.send ? elWrap.dataset.send : '';
	const dataSend = dataSendString ? JSON.parse( dataSendString ) : {};
	dataSend.filter_days = target.dataset.filter ? target.dataset.filter : '';

	elWrap.querySelectorAll( '.lp-btn-gradebook-filter' ).forEach( el => {
		el.classList.remove( 'active' );
	} );
	target.classList.add( 'active' );

	lpUtils.lpSetLoadingEl( target, 1 );

	const callBack = {
		success: ( response ) => {
			const { message, status, data } = response;

			if ( status !== 'success' ) {
				lpUtils.lpSetLoadingEl( target, 0 );
				alert( message );
				return;
			}

			const { labels, datasets } = data;
			renderBarChart( labels, datasets );

		},
		error: ( error ) => {
			console.log( error );
		},
		completed: () => {
			lpUtils.lpSetLoadingEl( target, 0 );
		}
	}

	window.lpAJAXG.fetchAJAX( dataSend, callBack );
}
let studentCourseBarChar;
const renderBarChart = ( labels = [], datasets = [] ) => {
	if (undefined === studentCourseBarChar) {
		const canvas = document.querySelector('.chart-canvas');
		const configBar = {
			type: 'bar',
			data: {
				labels: labels,
				datasets: datasets,
			},
			options: {
				responsive: true,
				maintainAspectRatio: false,
				aspectRatio: 1,
			},
		};
		studentCourseBarChar = new Chart(canvas, configBar);
	} else {
		studentCourseBarChar.data.labels = labels;
		studentCourseBarChar.data.datasets = datasets;
		studentCourseBarChar.update();
	}
};

document.addEventListener( 'click', ( e ) => {
	let target = e.target;
	exportCSV( e, target );
	showChart( e, target );
	filterChart( e, target );
} );
